import type { WeekIndicatorsValues } from 'core/api/home/weekly/useApiGetWeekIndicators'
import { daysArray } from './daily-board-utils'
import DailyDataUnavailable from './daily-data-unavailable'
import { useFormatNumber } from 'core/hooks/useFormatNumber'

interface DailyBoardMarginRatesProps {
  weeklyData: Record<number, WeekIndicatorsValues>
  isCurrentWeek: boolean
}

const DailyBoardMarginRates = ({ weeklyData, isCurrentWeek }: DailyBoardMarginRatesProps) => {
  const formatNumber = useFormatNumber()
  const today = new Date().getDay() + 1

  return (
    <>
      {daysArray.map(day => {
        const marginRate = weeklyData?.[day]?.margin_rate
        if (weeklyData == null || marginRate?.in_error) {
          return (
            <div key={day} className="vp-body-s mg-daily-board-item">
              <DailyDataUnavailable />
            </div>
          )
        }
        return (
          <div
            key={day}
            data-testid={`margin-rate-cell-${day}`}
            className={
              'vp-caption' + (isCurrentWeek && today === day ? ' mg-daily-board-item-today' : ' mg-daily-board-item')
            }
          >
            {formatNumber(marginRate?.value, '-', {
              style: 'percent',
              minimumFractionDigits: 1,
              maximumFractionDigits: 1
            })}
          </div>
        )
      })}
    </>
  )
}

export default DailyBoardMarginRates
